export default __webpack_public_path__ + "static/media/34.c1547939.jpg";